import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=f5574546&scoped=true&"
import script from "./AddCourse.vue?vue&type=script&lang=js&"
export * from "./AddCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCourse.vue?vue&type=style&index=0&id=f5574546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5574546",
  null
  
)

export default component.exports